import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

import { graphql, type DocumentType } from '@/gql';

const REPORT_QUERY_SELECT_REPORT_QUERY_FRAGMENT = graphql(`
  fragment reportQuerySelectReportQueryFields on ReportQuery {
    _id
    displayName
    shortName
    returnType
  }
`);

interface Props {
  reportQueries: Array<
    DocumentType<typeof REPORT_QUERY_SELECT_REPORT_QUERY_FRAGMENT>
  >;
  disabled?: boolean;
  showNoOneOption?: boolean;
  selectedQueryId: string;
  onReportQueryIdChange: (value: string) => void;
}

export const ReportQuerySelect = ({
  reportQueries,
  selectedQueryId,
  onReportQueryIdChange,
  disabled,
  showNoOneOption = false,
}: Props) => {
  return (
    <FormControl fullWidth size="small">
      {/* Always shrunk: displayEmpty renders "All Subscribers" for the empty
          value, which the resting label would otherwise overlap. */}
      <InputLabel id="report-query-select" shrink>
        Send this article as an email to...
      </InputLabel>
      <Select
        disabled={disabled}
        fullWidth
        labelId="report-query-select"
        label="Send this article as an email to..."
        notched
        value={selectedQueryId}
        onChange={(event) => {
          onReportQueryIdChange(event.target.value);
        }}
        displayEmpty
      >
        {showNoOneOption && <MenuItem value="no-one">No one</MenuItem>}
        <MenuItem value="">All Subscribers</MenuItem>
        {reportQueries.map((query) =>
          query && query._id ? (
            <MenuItem key={query._id} value={query._id || undefined}>
              {query.displayName}
            </MenuItem>
          ) : null,
        )}
      </Select>
    </FormControl>
  );
};
